module.exports = __webpack_public_path__ + "img/banner-21.8ca38d42.jpg";